/**
 * L’app stocke la dent en numérotation « universal » 1–32.
 * Le schéma clinique s’affiche en ISO/FDI (11–18, 21–28, 31–38, 41–48).
 * @see https://en.wikipedia.org/wiki/Universal_Numbering_System
 */
export const UNIVERSAL_TO_FDI = {
  1: 18,
  2: 17,
  3: 16,
  4: 15,
  5: 14,
  6: 13,
  7: 12,
  8: 11,
  9: 21,
  10: 22,
  11: 23,
  12: 24,
  13: 25,
  14: 26,
  15: 27,
  16: 28,
  17: 38,
  18: 37,
  19: 36,
  20: 35,
  21: 34,
  22: 33,
  23: 32,
  24: 31,
  25: 48,
  26: 47,
  27: 46,
  28: 45,
  29: 44,
  30: 43,
  31: 42,
  32: 41,
};

export const FDI_TO_UNIVERSAL = Object.fromEntries(
  Object.entries(UNIVERSAL_TO_FDI).map(([u, fdi]) => [fdi, Number(u)])
);

/** Arcades FDI, ordre d’affichage (de la droite vers la gauche du patient) */
export const FDI_UPPER = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
export const FDI_LOWER = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

export function fdiToUniversal(fdi) {
  return FDI_TO_UNIVERSAL[fdi] ?? null;
}

export function universalToFdi(universal) {
  return UNIVERSAL_TO_FDI[universal] ?? null;
}
